<!--首页轮播图 -->
  <template>
  <div class="carousel-container">
    <section @mouseenter="_stop" @mouseleave="_begin">
      <ul class="carousel-text" >
        <li
          :class="{active: currentIndex === index}"
          v-for="(item, index) in carouselList"
          :data-index="index"
          :key="index"
          @click="changePic"
        ></li>
      </ul>
      <transition-group tag="ul" class="carousel-img-container" name="fade">
        <li v-for="(item, index) in carouselList" :key="item.Title+item.Order" v-show="index===currentIndex">
          
             <div class="carousel-img" v-bind:style="{backgroundImage:'url(' + item.ImgUrl + ')'}">
               <a v-if="item.LinkUrl" :href="item.LinkUrl" target="_blank">
              </a>
              </div>   
        
        
      
        </li>
      </transition-group>
    </section>
  </div>
</template>
 
<script>
import {getBanner} from "../../assets/js/modules/indexApi"
import img1 from "../../assets/img/banner.jpg";
// import { error } from 'util';
export default {
  name: "c-carousel",
  data() {
    return {
      

      //  轮播图数据
      carouselList: [],
      //   当前正在显示的图片
      currentIndex: 0,
      //    切换图片定时器
      carouselTimer: null
    };
  },
  mounted() {
    this._begin();
  },
  methods: {
    //   点击切换图片
    changePic(e) {
      this.currentIndex = parseInt(e.target.dataset.index);
    
    },
    //  定时切换图片
    autoPlay() {
      this.currentIndex++;
      if (this.currentIndex >= this.carouselList.length) {
        this.currentIndex = 0;
      }
    },
    // 开始定时切换图片
    _begin() {
      this.carouselTimer = setInterval(this.autoPlay, 4000);
    },

    //  停止定时切换图片
    _stop() {
      clearInterval(this.carouselTimer);
    }
  },
  mounted(){
    let data = {
        "Sorting": "Id",
        "MaxResultCount": 5,
     };
     
    getBanner(data).then(res=>{
      
       this.carouselList=res.data.Data.Items;
    
      
    },error=>{
      console.log(error)
    }
    )
  },
};
</script>
<style scoped>

.carousel-container {
  position: relative;
}
.carousel-img-container {
  overflow: hidden;
  width: 100%;
  height: 500px;
  position: relative;
}
.carousel-img-container li {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
}
.carousel-img-container .li img {
  width: 100%;
  position: absolute;
}
.carousel-img {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.carousel-img a{
  display: block;
  width: 100%;
  height: 100%;
}
.carousel-text {
  position: absolute;
  bottom: 0;
  z-index: 99;
  left: 0;
  width: 100%;
  text-align: center;
}
.carousel-text li {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  margin: 15px;
  cursor: pointer;
}
.carousel-text li.active {
  background: #6b95ff;
}
/* // 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: all 2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transition: translateY(20px);
}
</style>






// WEBPACK FOOTER //
// src/components/common/rotation.vue